import { KeypadClear, KeypadDelete } from "./svg/Wallet/Wallet";

export const Keypad = ({
  onPinComplete,
  onPinChange,
  pin,
  setPin,
  pinLength,
}) => {
  const keys = [
    ["1", "2", "3"],
    ["4", "5", "6"],
    ["7", "8", "9"],
    ["↶", "0", "⌫"],
  ];

  const handleKeyPress = (key) => {
    if (key === "⌫") {
      // Backspace
      const newPin = pin.slice(0, -1);
      setPin(newPin);
      onPinChange?.(newPin);
    } else if (key === "↶") {
      // Clear all
      setPin("");
      onPinChange?.("");
    } else if (pin.length < pinLength) {
      // Add number
      const newPin = pin + key;
      setPin(newPin);
      onPinChange?.(newPin);

      // Check if PIN is complete
      if (newPin.length === pinLength) {
        onPinComplete?.(newPin);
      }
    }
  };

  return (
    <div>
      <div className=" pt-2 px-2 pb-3 ">
        <div className="grid grid-cols-3 gap-2">
          {keys.flat().map((key, index) => (
            <button
              key={index}
              onClick={() => handleKeyPress(key)}
              className={
                "min-w-20 w-full h-[53px] rounded-md bg-white font-normal text-3xl flex items-center justify-center "
              }
            >
              {key === "⌫" ? (
                <KeypadDelete />
              ) : key === "↶" ? (
                <KeypadClear />
              ) : (
                key
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
